import { render, staticRenderFns } from "./MelonTVScheduleList.vue?vue&type=template&id=2131269b&"
import script from "./MelonTVScheduleList.vue?vue&type=script&lang=js&"
export * from "./MelonTVScheduleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports